import type { Wallet } from './types'
export const PLAN_KINDS = {
  single_project: 'single_project',
  subscription: 'subscription',
  legacy_subscription: 'legacy_subscription',
  demo: 'demo',
} as const

export const WALLET_TITLES: Record<Wallet, string> = {
  pages: 'Page credits',
  screenings: 'Screenings credits',
}
